import { Form } from 'formik';
import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

import CheckBox from 'components/Checkbox';

export const AddContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;

  @media ${({ theme }) => theme.device.mobile} {
    flex-direction: row;

    width: 100%;
    height: 100%;
    z-index: 9;
    border-radius: 0;
    margin: 0;
    padding: 0;
    height: 100vh;
    overflow: scroll;
    background-color: ${ColorPalette.HEX.Lotion};
  }
`;

export const Container = styled.div`
  display: flex;
  flex: 1;
  width: 100%;
`;

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: 100%;

  @media ${({ theme }) => theme.device.mobile} {
    margin-top: 80px;
  }
`;

export const CardContainer = styled.div`
  padding-top: 10px;
  padding-bottom: 24px;

  @media ${({ theme }) => theme.device.mobile} {
    padding: 24px 30px 0 30px;
  }
`;

export const CheckBoxContainer = styled.div`
  padding-top: 32px;
  display: flex;
  flex-direction: row;
`;
export const CheckBoxStyled = styled(CheckBox)`
  display: flex;
  align-items: flex-start;
`;

export const CheckLabel = styled.label`
  padding: 0px;
  font-family: Poppins;
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  margin-left: 8px;
  color: ${ColorPalette.HEX.PineTree};
`;

export const FormContainer = styled(Form)`
  flex: 1;
  display: flex;
  flex-direction: column;

  > div {
    flex: none;
  }

  @media ${({ theme }) => theme.device.mobile} {
    padding: 64px 16px 0 16px;
  }
`;

export const GroupButton = styled.div`
  display: flex;
  flex: 1 !important;
  flex-direction: column-reverse;

  @media ${({ theme }) => theme.device.mobile} {
    margin-top: 16px;
    margin-bottom: 16px;
  }
`;
